<template>
  <div>
    <h2>You are not authorized to access this site, please contact your property manager for assistance.</h2>
    <p>{{message}}</p>
  </div>
</template>

<script>
import store from "@/store/store";

export default {
  name: "Unauthorized",
  props: {
    message: { type: String }
  },
  mounted() {
    store.dispatch("Unauthorized")
  }
}
</script>